module.exports = __webpack_public_path__ + "static/media/android-development-1024x683.64ac468b.png";